import $ from 'jquery'
import { animate } from '../functions'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const object = casanovaObject

$(document).on(
  'click',
  '.page-template-page-devis .seedling-ajax-post',
  function (e) {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    $('.seedling-search').autocomplete('close')

    const $this = $(this)
    const id = $this.attr('data-id')
    const container = $('.devis__seedlings-wrapper')
    const posts = $('.devis__seedling-posts')
    const check = posts.find(`#feed-seedling-devis-${id}`)

    if (check.length) {
      animate(check[0], 'headShake')
      return
    }

    $.ajax({
      url: object.ajaxUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        _ajax_nonce: object.nonce,
        action: 'casanova_get_devis_seedling',
        id,
      },
      beforeSend: () => {
        container
          .addClass('devis__seedlings-wrapper--loading')
          .append(object.loader)
      },
      success: (res) => {
        container.find('.casanova-loader').remove()
        container.removeClass('devis__seedlings-wrapper--loading')

        if (res.success) {
          posts.append(res.data.content)
          posts.find(`#feed-seedling-devis-${id}`).slideDown(250)
        }
      },
    })
  }
)

$(document).on('click', '.feed-seedling-devis__remove', function () {
  const post = $(this)
  const parent = post.closest('.feed-seedling-devis')

  parent.slideUp(250, () => parent.remove())
})

$('.devis').parsley()

$('.devis').on('submit', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()

  const $form = $(this)

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: $form.serialize() + '&action=' + 'casanova_devis_handler',
    beforeSend: () => {
      $form.addClass('sending')
      Alert('warning', object.formWait, false)
    },
    success: (res) => {
      $form.removeClass('sending')

      if (res.success && res.data.redirect) {
        window.location.href = res.data.redirect
      }

      if (!res.success) {
        Alert(res.success, res.data.message)
      }
    },
  })
})
